(() => {
  if (customElements.get('ih-google-review-reel')) return;
  class IronhaulGoogleReviewReel extends HTMLElement {
    connectedCallback() {
      if (this.dispose) this.dispose();
      const button = this.querySelector('[data-ih-review-toggle]');
      if (!button) return;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const syncButton = () => {
        const paused = this.dataset.paused === 'true';
        button.hidden = reduced.matches;
        button.setAttribute('aria-pressed', String(paused));
        button.textContent = paused ? button.dataset.resumeLabel : button.dataset.pauseLabel;
      };
      const toggle = () => { this.dataset.paused = String(this.dataset.paused !== 'true'); syncButton(); };
      const visibility = () => { this.dataset.documentHidden = String(document.hidden); };
      const keyboardIntent = event => { if (event.key === 'Tab') this.keyboardIntent = true; };
      const pointerIntent = () => { this.keyboardIntent = false; };
      const focusIn = event => {
        if (!this.keyboardIntent || !event.target.closest('a')) return;
        this.dataset.keyboard = 'true';
        requestAnimationFrame(() => event.target.scrollIntoView({block:'nearest',inline:'nearest'}));
      };
      const focusOut = event => {
        if (this.contains(event.relatedTarget)) return;
        this.dataset.keyboard = 'false';
        this.querySelectorAll('.ih-review-reel__viewport').forEach(viewport => { viewport.scrollLeft = 0; });
      };
      const observer = new IntersectionObserver(entries => {
        this.dataset.offscreen = String(!entries[0].isIntersecting);
      }, {rootMargin:'80px'});
      observer.observe(this);
      button.addEventListener('click', toggle);
      document.addEventListener('keydown', keyboardIntent, true);
      this.addEventListener('pointerdown', pointerIntent, true);
      this.addEventListener('focusin', focusIn);
      this.addEventListener('focusout', focusOut);
      document.addEventListener('visibilitychange', visibility);
      reduced.addEventListener('change', syncButton);
      syncButton(); visibility();
      this.dispose = () => {
        observer.disconnect();
        button.removeEventListener('click', toggle);
        document.removeEventListener('keydown', keyboardIntent, true);
        this.removeEventListener('pointerdown', pointerIntent, true);
        this.removeEventListener('focusin', focusIn);
        this.removeEventListener('focusout', focusOut);
        document.removeEventListener('visibilitychange', visibility);
        reduced.removeEventListener('change', syncButton);
      };
    }
    disconnectedCallback() { if (this.dispose) this.dispose(); this.dispose = null; }
  }
  customElements.define('ih-google-review-reel', IronhaulGoogleReviewReel);
})();
